module.exports = __webpack_public_path__ + "img/foreign_default.f0f03f3.png";